import { httpsCallable } from "firebase/functions";
import { createResult, getFnResponseData } from "global/altFunctions/common";
import _ from 'lodash';

const _showCallLogs = false

export const fsCallAll = async (mainFunctions, genericType, callData, allFunctions, useProd) => {

  let ft;
  const _keys = Object.keys(callData)

  if (_keys) {
    _keys.forEach(key => {
      if (key.endsWith('FunctionType')) {
        ft = callData[key];
      }
    })
  }

  const _fns = mainFunctions //useProd && allFunctions['prodFunctions'] ? allFunctions['prodFunctions'] : mainFunctions

  // console.log('_fns', _fns)

  // const fd = _.get(mainFunctions, 'app._options.authDomain', null)
  // _showCallLogs && console.log('functionsDomain', fd)
  // _showCallLogs && console.log(' > fsCall: callData:', genericType, ft, callData)

  try {
    const _rsp = (await httpsCallable(_fns, genericType)(callData))
    _showCallLogs && console.log(' < fsCall: response:', _rsp)
    return getFnResponseData(_rsp)
  } catch (error) {
    _showCallLogs && console.log(' < fsCall: error:', error)
    // const _docRef = createRefPath(['_funtionsError', 'app', _settingsFs.collection, sk])
    // promises.push(database_fns.set_doc(_docRef, setting, true))
    return createResult(false, {}, error)
  }
}

export const fsCall_generic = async (functionsInstance, functionType, callData) => {
  try {
    _showCallLogs && console.log(' > fsCall_generic', functionType, callData)
    const _rsp = (await httpsCallable(functionsInstance, functionType)(callData))
    _showCallLogs && console.log(' < fsCall_generic', _rsp)
  } catch (error) {
    console.log('callFunction - error', error)
  }
}
